import { render, staticRenderFns } from "./TwoPlayerPKGame.vue?vue&type=template&id=5d75c97e"
import script from "./TwoPlayerPKGame.vue?vue&type=script&lang=js"
export * from "./TwoPlayerPKGame.vue?vue&type=script&lang=js"
import style0 from "./TwoPlayerPKGame.vue?vue&type=style&index=0&id=5d75c97e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports